import React, { useState, useRef } from 'react'
import { Link } from 'react-router-dom'

import Logo from './newComponents/Logo'
import useCart from 'store/CartProvider'
import Phone from 'components/Icons/landingPhone'
import SearchInput from './newComponents/SearchInput'
import HeaderActions from './newComponents/HeaderActions'
import CallRequestForm from './newComponents/CallRequestForm'
import { useWishlistContext } from '../../store/WishlistContext'

const Header = () => {
  const [isCartOpen, setIsCartOpen] = useState(false)
  const [isWishlistOpen, setIsWishlistOpen] = useState(false)

  const cartRef = useRef(null)
  const wishlistRef = useRef(null)

  const { products } = useCart()
  const { wishlistProducts } = useWishlistContext()

  const handleWishlistToggle = () => {
    setIsWishlistOpen(prev => !prev)
    setIsCartOpen(false)
  }

  const handleCartToggle = () => {
    setIsCartOpen(prev => !prev)
    setIsWishlistOpen(false)
  }

  const commonActionsProps = {
    wishlistRef,
    cartRef,
    wishlistCount: wishlistProducts.length,
    cartCount: products.length,
    isWishlistOpen,
    isCartOpen,
    onWishlistToggle: handleWishlistToggle,
    onCartToggle: handleCartToggle,
    onWishlistClose: () => setIsWishlistOpen(false),
    onCartClose: () => setIsCartOpen(false),
  }

  return (
    <React.Fragment>
      <div className="fixed left-0 right-0 z-[100]">
        {/* <div className="bg-slate-50 border-b border-b-slate-200 text-center py-2 text-xs md:text-sm">
          <Link
            to="/page/delivery-schedule"
            className="text-citrus-red hover:underline"
          >
            ლოგისტიკური პროცესების გაუმჯობესების მიზნით შესაძლოა შეკვეთების მიწოდება შეფერხდეს. დეტალურად იხილეთ აქ →
          </Link>
        </div> */}
        <div className="border-b border-slate-200 md:py-3 bg-white">
          <div className="hidden md:flex items-center container justify-between gap-6">
            <Logo />
            <SearchInput />

            <div className="flex flex-col relative group">
              <div className="flex flex-col cursor-pointer">
                <p className="text-[13px] text-slate-600 mb-1">
                  შეკვეთა 10:00-21:00
                </p>
                <a
                  href="tel:0322423500"
                  className="font-semibold text-citrus-red flex justify-between items-center text-base"
                >
                  <Phone
                    height="16"
                    width="16"
                    fill="#ef4444"
                    className="mb-[2px]"
                  />
                  <span>032 2 80 02 02</span>
                </a>
              </div>

              <CallRequestForm />
            </div>

            <HeaderActions {...commonActionsProps} />
          </div>

          <div className="md:hidden px-2 py-3">
            <div className="flex items-center justify-between gap-3">
              <Logo isMobile />
              <SearchInput isMobile />
              <HeaderActions {...commonActionsProps} isMobile />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Header
